/**
 * Video Banner Functionality.
 * 
 * Start incorporating the arrive.js library to use DOM ready less
 */
(function($) {
    let arriveOptions = {
        onceOnly: true, // ensure that registered callbacks fire only once
        existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
    };

    let videoBanner = '.most-video-banner';
    let video = videoBanner + ' video';
    
    function videoBannerInit() {
        $(this).addClass('open');
        $(this).trigger('play'); // avoid any browsers ignoring autoplay
    }

    $(document).arrive(video, arriveOptions, videoBannerInit);

}) (jQuery);
